import state from './overviewState';
import { mutations, actions, getters } from './overview';

export default {
    state() {
        return {
            ...state,
            defaultFavorite: [
                'contacts_fullName',
                'contacts_email',
                'contacts_mobile',
                'informations_domain',
            ],
        };
    },
    mutations: {
        ...mutations,
        buildFavorites(state, { getters }) {
            let groupWithFavorites = ['informations', 'contacts', 'financial', 'legal'];

            _.each(groupWithFavorites, (groupName) => {
                if (getters[groupName]) {
                    _.each(getters[groupName], (itemGroup) => {
                        if (getters['activeFavorites'].includes(itemGroup.favoriteName)) {
                            state.favorites.push(itemGroup);
                        }
                    });
                } else {
                    _.each(state.dataMap[groupName], (itemGroup) => {
                        if (getters['activeFavorites'].includes(itemGroup.favoriteName)) {
                            itemGroup.value = '-';
                            itemGroup.link = 'javascript:;';
                            state.favorites.push(itemGroup);
                        }
                    });
                }
            });
        },
    },
    actions: {
        ...actions,
    },
    getters: {
        ...getters,
        informations: (state) => {
            state.dataMap.informations.map((map) => {
                let info = state.dataFetch.informations.find((info) => info.key == map.id);
                map.value = info !== undefined ? info.value : '';
                map.linkedtype = state.linkedtype;
                map.linkedid = state.linkedid;
            });
            return state.dataMap.informations;
        },
        financial: (state) => {
            state.dataMap.financial.map((map) => {
                let info = state.dataFetch.financial.find((info) => info.key == map.id);
                map.value = info !== undefined ? info.value : '';
            });
            return state.dataMap.financial;
        },
        legal: (state) => {
            state.dataMap.legal.map((map) => {
                let info = state.dataFetch.legal.find((info) => info.key == map.id);
                map.value = info !== undefined ? info.value : '';
            });
            return state.dataMap.legal;
        },
        contacts: (state, getters) => {
            if (getters.isCorporation) {
                let mainContact = getters.mainContact;
                if (mainContact) {
                    state.dataMap.contacts.map((map) => {
                        map.value = mainContact[map.id];
                        map.link = mainContact['link'];
                        map.linkedtype = 'people';
                        map.linkedid = parseInt(mainContact['peopleId']);
                    });
                    return state.dataMap.contacts;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        isCorporation: (state) => {
            return state.identity.isCorporation;
        },
    },
};
